/* eslint-disable @typescript-eslint/no-unused-vars */
import { memberPathPrefix } from "../../../path";

function createPath(path: string, stripPrefix: string = ""): string {
  let concatenatedPath = `${memberPathPrefix}${path}`;

  if (stripPrefix && concatenatedPath.startsWith(stripPrefix)) {
    concatenatedPath = concatenatedPath.substring(stripPrefix.length);
  }

  return concatenatedPath;
}

type PathFunction = (
  asPathName?: boolean,
  stripPrefix?: string,
  ...args: string[]
) => string;

export const CLIENT_DETAILS_PATH: PathFunction = (
  asPathName: boolean = false,
  stripPrefix: string = "",
  code?: string,
) => createPath(`/clients/${asPathName ? ":code" : code}`, stripPrefix);

export const CLIENT_LIST_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/clients`, stripPrefix);

export const INVOICE_DETAILS_PATH: PathFunction = (
  asPathName: boolean = false,
  stripPrefix: string = "",
  id: string,
) => createPath(`/invoices/${asPathName ? ":code" : id}`, stripPrefix);

export const INVOICE_LIST_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/invoices`, stripPrefix);

export const INTERAC_LIST_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/interac`, stripPrefix);

export const INVITATION_DECISION_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/invitation`, stripPrefix);

export const LOGIN_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/login`, stripPrefix);

export const REQUEST_PASSWORD_RESET_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/request-password-reset`, stripPrefix);

export const RECURRING_INVOICE_LIST_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/recurring-invoices`, stripPrefix);

export const RECURRING_INVOICE_NEW_FORM: PathFunction = (
  _: boolean = false,
  stringPrefix: string = "",
) => createPath(`/recurring-invoices/new`, stringPrefix);

export const RECURRING_INVOICE_DETAILS_PATH: PathFunction = (
  asPathName: boolean = false,
  stripPrefix: string = "",
  code: string,
) =>
  createPath(`/recurring-invoices/${asPathName ? ":code" : code}`, stripPrefix);

export const SIGNUP_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/signup`, stripPrefix);

export const SURCHARGE_DETAILS_PATH: PathFunction = (
  asPathName: boolean = false,
  stripPrefix: string = "",
  id: string,
) => createPath(`/surcharges/${asPathName ? ":code" : id}`, stripPrefix);

export const SURCHARGE_LIST_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/surcharges`, stripPrefix);

export const TAXES_LIST_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/taxes`, stripPrefix);

export const TAXES_DETAILS_PATH: PathFunction = (
  asPathName: boolean = false,
  stripPrefix: string = "",
  id: string,
) => createPath(`/taxes/${asPathName ? ":code" : id}`, stripPrefix);

export const TRANSACTION_DETAILS_PATH: PathFunction = (
  asPathName: boolean = false,
  stripPrefix: string = "",
  code: string,
) => createPath(`/transactions/${asPathName ? ":code" : code}`, stripPrefix);

export const TRANSACTIONS_LIST_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/transactions`, stripPrefix);

export const VERIFY_TWO_FA_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/verify-two-fa`, stripPrefix);

export const PASSWORD_RESET_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/password-reset`, stripPrefix);

export const VERIFY_YOUR_EMAIL: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/verify-your-email`, stripPrefix);

export const EMAIL_VERIFICATION_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/verify-email`, stripPrefix);

export const FORMS_DETAILS_PATH: PathFunction = (
  asPathName: boolean = false,
  stripPrefix: string = "",
  code?: string,
) => createPath(`/forms/${asPathName ? ":code" : code || ""}`, stripPrefix);

export const PROJECT_LIST_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/projects`, stripPrefix);

export const PROJECT_DETAILS_PATH: PathFunction = (
  asPathName: boolean = false,
  stripPrefix: string = "",
  code?: string,
) => createPath(`/projects/${asPathName ? ":code" : code}`, stripPrefix);

export const DASHBOARD_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/dashboard`, stripPrefix);

export const TIME_ENTRIES_LIST_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/time-entries`, stripPrefix);

export const FORMS_LIST_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/forms`, stripPrefix);

export const FORM_NEW_FORM: PathFunction = (
  _: boolean = false,
  stringPrefix: string = "",
) => createPath(`/forms/new`, stringPrefix);
